import { render, staticRenderFns } from "./EndPaymentPage.vue?vue&type=template&id=5f9296b4&"
import script from "./EndPaymentPage.vue?vue&type=script&lang=js&"
export * from "./EndPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./EndPaymentPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports